import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

// NOT_IN_USE
@Component({
    selector: 'cm-contract-objects-navigation-consultant',
    templateUrl: './cm-contract-objects-navigation-consultant.component.html',
    standalone: false
})
export class CmContractObjectsNavigationConsultantComponent
    implements OnInit, OnChanges, OnDestroy {

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {

    }

    ngOnDestroy() {

    }

}
